import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { DeleteDialogComponent } from '@klickdata/core/application';
import { AuthService } from '@klickdata/core/auth';
import { MessageDeletedComponent, MessageService } from '@klickdata/core/message';
import { MobileService } from '@klickdata/core/mobile';
import { ResourceTypes } from '@klickdata/core/resource';
import { Section, SectionPublicOrder, SectionService } from '@klickdata/core/section';
import { GlobalFilterProperty, SelectFilterOption } from '@klickdata/core/table';
import { Utils } from '@klickdata/core/util';
import { filter, first, switchMap, takeUntil } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Customer } from '@klickdata/core/customer';
import { SectionSelectDatatableService } from '../section-select-datatable.service';
import { SelectModelBaseDirective } from '../../select-model-base/select-model-base.component';
import { BrowseFolderComponent } from '@klickdata/shared-components/src/folder/browse-folder/browse-folder.component';

@Component({
    selector: 'app-cluster-section-select',
    templateUrl: './cluster-section-select.component.html',
    styleUrls: ['./cluster-section-select.component.scss'],
    providers: [SectionSelectDatatableService],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClusterSectionSelectComponent extends SelectModelBaseDirective<Section> {
    @Input() accessForm: FormGroup;
    @Input() referenceFilter: string;
    @Input() referencePropertyValue: string;
    @Input() sync_all_key = 'sync_all_sections';
    @Input() attachKey = 'sections_attach';
    @Input() detachKey = 'sections_detach';
    columns: string[] = ['select', 'title', 'updated_at'];
    public itemSelectedOptions: SelectFilterOption[];
    GlobalFilterProperty = GlobalFilterProperty;

    constructor(
        public datatableService: SectionSelectDatatableService,
        protected bottomSheet: MatBottomSheet,
        protected mobileService: MobileService,
        protected sectionService: SectionService,
        protected dialog: MatDialog,
        protected auth: AuthService,
        protected messageService: MessageService,
        protected cdRef: ChangeDetectorRef
    ) {
        super(datatableService, mobileService);
        this.itemSelectedOptions = Utils.getItemSelectedOptions();
    }

    protected refresh(id: any): void {
        this.filter.createOrUpdateFilter([{ property: this.referenceFilter, items: [this.referencePropertyValue] }]);
    }
}
